import { Component } from "@angular/core";
import { IsolationRoomMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/floorplan-monitoring-zone-menu/isolation-room/isolation-room-menu.component";
import { ItRoomMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/floorplan-monitoring-zone-menu/it-room/it-room-menu.component";
import { OperatingTheatreMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/floorplan-monitoring-zone-menu/operating-theatre/operating-theatre-menu.component";
import { ProcedureRoomMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/floorplan-monitoring-zone-menu/procedure-room/procedure-room-menu.component";
import { StandardRoomMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/floorplan-monitoring-zone-menu/standard-room/standard-room-menu.component";

@Component({
  selector: "app-floorplan-monitoring-zone-menu",
  imports: [
    StandardRoomMenuComponent,
    ItRoomMenuComponent,
    ProcedureRoomMenuComponent,
    OperatingTheatreMenuComponent,
    IsolationRoomMenuComponent,
  ],
  templateUrl: "./floorplan-monitoring-zone-menu.component.html",
  styleUrl: "./floorplan-monitoring-zone-menu.component.scss",
})
export class FloorplanMonitoringZoneMenuComponent {}
